import store from '../store';
import db from './db';
import { isTrialFullAccess } from './platformSubscription';

function permissions() {
    const fromStore = store.state.auth.permissions;

    if (Array.isArray(fromStore)) {
        return fromStore;
    }

    return db.permissions ?? [];
}

export default class permission {
    static has(permission) {
        if (db.user?.is_admin) {
            return true;
        }

        if (isTrialFullAccess()) {
            return true;
        }

        const granted = permissions();

        if (!permission || granted.length === 0) {
            return false;
        }

        return granted.includes(permission);
    }
}
